<div class="wrapper">
  <span class="headline" [innerHtml]="data.text | safeHTML"></span>

  <mat-form-field>
    <input matInput [formControl]="password" />
  </mat-form-field>
  <mat-error *ngIf="invalid">{{ data.error }}</mat-error>

  <button class="okButton" mat-flat-button (click)="onOkay()">OK</button>
</div>
